module.exports = __webpack_public_path__ + "6c77f72351174a000a4e2a9428f4bec0.png";